module.exports = __webpack_public_path__ + "static/media/JSNLC2.cb10b73e.png";